import CopyToClipboard from 'react-copy-to-clipboard'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {blockPopUp} from '../../../../../../gori/helpers'
import {KTSVG} from '../../../../../../gori/components'
import {getCSSVariableValue} from '../../../../../../gori/assets/ts/_utils'
import {isEmpty} from 'lodash'

type OrderTrackingNumberCellProps = {
  trackingNumbers: string[] | null
  isMultiParcel: boolean
  service: any
  onClickTrackingNumbersDetail: () => void
}

export const OrderTrackingNumberCell = ({
  trackingNumbers,
  isMultiParcel,
  service,
  onClickTrackingNumbersDetail,
}: OrderTrackingNumberCellProps) => {
  const intl = useIntl()
  const baseColor = getCSSVariableValue('--bs-primary')

  return (
    <div>
      {trackingNumbers && !isEmpty(trackingNumbers) && !isMultiParcel ? (
        <div className='d-flex justify-content-center'>
          <div className='align-self-center'>
            <span
              className='text-primary cursor-pointer'
              onClick={() => {
                if (blockPopUp(service?.visuals?.tracking_url + trackingNumbers[0])) {
                  toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                }
              }}
            >
              {trackingNumbers[0]}
            </span>
          </div>
          <CopyToClipboard
            text={trackingNumbers[0]}
            onCopy={() => toast.success(intl.formatMessage({id: 'COPIED'}))}
          >
            <div>
              <div className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'>
                <KTSVG path='/media/gori/common/copy.svg' className='svg-icon' />
              </div>
            </div>
          </CopyToClipboard>
        </div>
      ) : (
        ''
      )}

      {trackingNumbers && !isEmpty(trackingNumbers) && isMultiParcel ? (
        <div className='d-flex align-items-center gap-1 cursor-pointer justify-content-center'>
          <span className='fs-7 text-primary' onClick={onClickTrackingNumbersDetail}>
            {intl.formatMessage({id: 'TRACKING_NUMBERS'})}
            <KTSVG
              path='/media/gori/common/external_link.svg'
              className='svg-icon ps-1'
              style={{stroke: baseColor}}
            />
          </span>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
